import { DataSource } from '@angular/cdk/collections';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import {map, switchMap} from 'rxjs/operators';
import {Observable, merge, of} from 'rxjs';
import {RentalPropertyModel} from "../../../../domain/models/rental-property.model";
import {PropertyService} from "../../../../domain/services/property/property.service";
import {PropertySearchFilterComponent} from "../property-search-filter/property-search-filter.component";

export class PropertySearchListDataSource extends DataSource<RentalPropertyModel> {
  data: RentalPropertyModel[] = [];
  paginator: MatPaginator | undefined;
  sort: MatSort | undefined;
  filter: PropertySearchFilterComponent | undefined;

  constructor(private readonly propertyService: PropertyService) {
    super();
  }

  connect(): Observable<RentalPropertyModel[]> {
    if (this.paginator && this.sort && this.filter) {
      return merge(of(this.data), this.paginator.page, this.sort.sortChange, this.filter.filterChanged)
        .pipe(
          switchMap(() => this.getProperties())
        );
    } else {
      throw new Error('Please set the paginator and sort on the data source before connecting.');
    }
  }

  loadProperties(): Observable<RentalPropertyModel[]> {
    const sortStr = this.sort?.active ? `${this.sort.active},${this.sort.direction}` : '';
    return this.propertyService.getAllPaged4(
      this.paginator?.pageIndex ?? 0,
      this.paginator?.pageSize ?? 10,
      sortStr,
      this.filter?.filters ?? new Map<string,string>()
    ).pipe(
      map(data => {
        if (this.paginator) {
          this.paginator.length = data.totalElements ?? 0;
          this.paginator.pageSize = data.size ?? 10;
          this.paginator.pageIndex = data.number ?? 0;
        }
        return data.content as RentalPropertyModel[];
      })
    );
  }

  getProperties(): Observable<RentalPropertyModel[]> {
    return this.loadProperties();
  }

  disconnect(): void {}
}
